
// require('bootstrap/scss/bootstrap.scss');

// require('@fortawesome/fontawesome-free/css/all.css');
require('@fancyapps/fancybox/dist/jquery.fancybox.css');
require('@fancyapps/fancybox/dist/jquery.fancybox.min.js');

Vue.component("catalog", () => import("./components/Catalog.vue"));
Vue.component("catalog-item", () => import("./components/CatalogItem.vue"));
Vue.component("catalog-detail-popup", () => import("./components/CatalogDetailPopup.vue"));
Vue.component("cart", () => import("./components/Cart.vue"));
Vue.component("popup", () => import("./components/Popup.vue"));
Vue.component("input-mask", () => import("./components/InputMask.vue"));
Vue.component("input-phone", () => import("./components/InputPhone.vue"));
Vue.component("input-date", () => import("./components/InputDate.vue"));
Vue.component("order-form", () => import("./components/OrderForm.vue"));

Vue.component("catalog-sections", () => import("./components/panel/CatalogSections.vue"));
Vue.component("catalog-section", () => import("./components/panel/CatalogSection.vue"));
Vue.component("catalog-products", () => import("./components/panel/CatalogProducts.vue"));
Vue.component("catalog-product", () => import("./components/panel/CatalogProduct.vue"));
Vue.component("banners", () => import("./components/panel/Banners.vue"));
Vue.component("banner", () => import("./components/panel/Banner.vue"));



import Cookies from 'js-cookie';

import Vue from "vue";
import Vuex      from "vuex";
Vue.use(Vuex);
import store     from "./store";
window.Vue = Vue;

let $ = window.$ || {};

import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

const i18n = new VueI18n({
    locale: 'ru', // установка локализации по умолчанию
    messages : {
        en: {
            message: ''
        },
        ru: {
            message: ''
        }
    },
    silentTranslationWarn : true,
    missing (locale, key, vm, values) {
        return '';
    },
});

function number_format( number, decimals, dec_point, thousands_sep )
{
    var i, kw, kd;
    if( isNaN(decimals=Math.abs(decimals)) )
    {
        decimals=2;
    }
    if( dec_point == undefined )
    {
        dec_point=",";
    }
    if( thousands_sep == undefined )
    {
        thousands_sep=".";
    }
    i =parseInt(number=( +number || 0 ).toFixed(decimals)) + "";
    kw=i.split(/(?=(?:\d{3})+$)/).join(thousands_sep);
    kd=( decimals ? dec_point + Math.abs(number - i).toFixed(decimals).replace(/-/, 0).slice(2) : "" );
    return kw + kd;
}

window.plural = function( number, words )
{
    let n=Math.abs(number);
    n%=100;
    if( n >= 5 && n <= 20 )
    {
        return words[ 2 ];
    }
    n%=10;
    if( n === 1 )
    {
        return words[ 0 ];
    }
    if( n >= 2 && n <= 4 )
    {
        return words[ 1 ];
    }
    return words[ 2 ];
}

Vue.filter("phoneFormat", phone =>
{
    phone=phone.replace(/[^\d]/g, "");
    if( phone.length != 11 )
    {
        return phone;
    }
    return phone.replace(/\d(\d{3})(\d{3})(\d{2})(\d{2})/, "8-$1-$2-$3-$4");
});

Vue.filter("plural", function( value, words )
{
    return window.plural(value, words);
});

Vue.filter("numberFormat", function( value )
{
    return number_format(value, 0, ".", " ");
});

Vue.filter("priceFormat", function( v ) {
    return number_format(v, 2, ".", " ").replace('.00', '');
});



if( window.frameCacheVars !== undefined && window.BX) {
    window.BX.addCustomEvent("onFrameDataReceived", function( /* json */ ) {
        afterCompositeLoaded();
    });
}
else {
    if( window.BX ) {
        window.BX.ready(() => { afterCompositeLoaded(); });
    }
    else {
        document.addEventListener('DOMContentLoaded', () => afterCompositeLoaded());
    }
}

function onCompositeFail()
{
    if( ~window.location.href.indexOf("?") )
    {
        window.location.href=window.location.href + "&ncc=1";
    }
    else
    {
        window.location.href=window.location.href + "?ncc=1";
    }
}
if (window.BX) {
    window.BX.addCustomEvent("onFrameDataRequestFail", function( /* response */ ) {
        onCompositeFail();
    });
}
if( !~window.location.href.indexOf("ncc=1") )
{
    window.compositeFailTimeout=setTimeout(
        function()
        {
            onCompositeFail();
        },
        5000,
    );
}

function afterCompositeLoaded()
{
    clearTimeout(window.compositeFailTimeout);
    window.App = new Vue({
        store,
        i18n,
        el : "#app",
        data : {
            processed : false,
            headerMessageTimeout : null,
            headerMessage : '',
            message : '',
            cartOpened : false,
            search : '',
            headSearchVisible : false,
        },
        mounted () {
            this.$store.dispatch('loadCartData');
            this.$store.dispatch('loadInitData').then(()=>{
                setTimeout(()=>{
                    this.$i18n.locale = this.selectedLanguage.CODE;
                    this.loadTranslates();
                }, 100)
                this.checkUnavailableSections();
            });

        },
        computed : {
            productTypes () {
                let items = {};
                let productTypes = this.$store.state.productTypes || [];
                for (var i = 0; i < productTypes.length; i++) {
                    items[ productTypes[i].ID ] = productTypes[i];
                }
                return items;
            },
            cartItems () {
                return this.$store.state.cart.items || [];
            },
            langs () {
                return this.$store.state.langs || [];
            },
            placeLangs () {
                return this.$store.state.placeLangs || [];
            },
            selectedLangId () {
                if(!this.$store.state.selectedLangId || this.$store.state.selectedLangId==='undefined')
                {
                    return 2955;
                }
                return +this.$store.state.selectedLangId;//сделать по-человечески. если не выбрать id то он приходит пустой
            },
            selectedLanguage(){
                let foundLang = {};
                if(+this.selectedLangId && this.langs.length>0)
                {

                    this.langs.forEach(lang=>{
                        // console.log(lang);
                        if(+lang.ID === +this.selectedLangId)
                        {
                            foundLang = lang;
                            return;
                        }
                    });
                }
                return foundLang;
            }
        },
        methods  : {
            loadTranslates () {
                fetch('/api/v1/translates/')
                .then(res => res.json())
                .then(res => {
                    this.$i18n.mergeLocaleMessage((this.selectedLanguage.CODE||'').toUpperCase(), res.messages);
                });
            },
            setSelectedLangId (langId) {
                this.$store.commit('setSelectedLangId', langId);
                location.reload();
            },
            checkUnavailableSections () {
                document.querySelectorAll('[data-shedule]').forEach((elem) => {
                    let curDate = new Date();
                    let dateStart = new Date();
                    let dateEnd = new Date();
                    if (this.$store.state.serverTimestamp) {
                        curDate.setTime(+this.$store.state.serverTimestamp * 1000);
                        dateStart.setTime(+this.$store.state.serverTimestamp * 1000);
                        dateEnd.setTime(+this.$store.state.serverTimestamp * 1000);
                    }
                    let timezone;
                    let timezoneDiff = 0;
                    if (timezone = +elem.getAttribute('data-timezone')) {
                        timezoneDiff = timezone + (curDate.getTimezoneOffset() / 60);
                    }

                    dateStart.setHours(0);
                    dateStart.setMinutes(0);
                    dateEnd.setHours(23);
                    dateEnd.setMinutes(59);
                    let shedule;
                    try {
                        shedule = JSON.parse(elem.getAttribute('data-shedule'));
                    } catch (e) {
                        console.log(e);
                        return;
                    }
                    let weekDay = curDate.getDay() || 7;
                    if ( shedule[ weekDay ] ) {
                        let timeStart = (shedule[ weekDay ].start||'').split(':');
                        let timeEnd = (shedule[ weekDay ].end||'').split(':');

                        if (timeStart.length) {
                            if (!isNaN(timeStart[0]) && !isNaN(timeStart[1])) {
                                dateStart.setHours(+timeStart[0] + timezoneDiff);
                                dateStart.setMinutes(+timeStart[1]);
                            }
                        }
                        if (timeEnd.length) {
                            if (!isNaN(timeEnd[0]) && !isNaN(timeEnd[1])) {
                                dateEnd.setHours(+timeEnd[0] + timezoneDiff);
                                dateEnd.setMinutes(+timeEnd[1]);
                            }
                        }
                        let isAvailable = true;
                        isAvailable = +curDate > +dateStart && +curDate < +dateEnd;
                        if (!isAvailable) {
                            console.log(curDate, dateStart, dateEnd, timezoneDiff);
                            elem.classList.add('unavailable');
                            // перемешаем в конец контейнера-родителя
                            elem.parentNode.appendChild(elem);
                        }
                    }
                });
            },
            showCart () {
                this.cartOpened = true;
            },
            initMap() {
                return new Promise(resolve => {
                    if( !window.ymaps ) {
                        var script =document.createElement("script");
                        script.src ="https://api-maps.yandex.ru/2.1/?lang=ru_RU";
                        script.onload=() => {
                            window.ymaps.ready(() => {
                                resolve();
                            });
                        };
                        document.body.appendChild(script);
                    }
                    else
                    {
                        window.ymaps.ready(() => {
                            resolve();
                        });
                    }
                });
            },
            initRecaptcha() {
                var script =document.createElement("script");
                script.src ="https://www.google.com/recaptcha/api.js?render=" + this.$store.state.recaptchaSiteKey;
                script.onload = () => {
                    window.grecaptcha.ready(() => {
                        $("form").on("click", e => {
                            var $form =$(e.currentTarget);
                            var $input=$form.find("[name=\"recaptcha_token\"]");
                            var action=$input.data("action-id");
                            if( !$input.val() && !$input.hasClass("recaptcha-processed") )
                            {
                                $input.addClass("recaptcha-processed");
                                window.grecaptcha.execute(this.$store.state.recaptchaSiteKey, {
                                    action,
                                }).then(token => {
                                    $($input).val(token);
                                });
                            }
                        });
                    });
                };
                document.body.appendChild(script);
            },
            showMessage( message ) {
                if( !message ) {
                    return;
                }
                alert(message);
                // return new Promise(( resolve ) =>
                // {
                //     this.message = message;
                //     let popupCheckInterval=setInterval(() => {
                //         if( this.$refs.Popup ) {
                //             clearInterval(popupCheckInterval);
                //             this.$refs.Popup.open()
                //             .then(action => {
                //                 resolve(action);
                //             });
                //         }
                //     }, 1000);
                // });
            },
            sendSmsCode( phone ) {
                return new Promise(( resolve ) => {
                    phone=phone.replace(/[^\d]/g, "");
                    fetch(`/api/v1/send-sms-code/${phone}/`, {
                        method : "POST",
                    })
                    .then(res => res.json())
                    .then(res => {
                        resolve(res);
                    });
                });
            },
            cookie( name, val, options={} ) {
                if( typeof ( val ) == "undefined" ) {
                    return Cookies.get(name);
                }
                else {
                    Cookies.set(name, val, Object.assign({expires : 30}, options));
                }
            },
        },
        watch : {
            cartOpened (cartOpened) {
                if (cartOpened) {
                    $('body').addClass('details-opened');
                }
                else {
                    $('body').removeClass('details-opened');
                }
            },
        },
    });
}
